'use client';

import type { ReactNode } from 'react';
import { MagneticCta } from '@/components/marketing/MagneticCta';

/**
 * Backwards-compatible wrapper around the canonical {@link MagneticCta}
 * primitive. Kept as a thin shim so existing imports under `/faq`
 * continue to work; new code should import `MagneticCta` directly.
 */
export function FaqMagneticCta({ children }: { children: ReactNode }) {
  return (
    <MagneticCta className="v4-faq-magnet">
      {children}
    </MagneticCta>
  );
}
